import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

const SignaturePad = ({ onSave, onCancel, documentType, documentNumber, clientName }) => {
  const sigCanvas = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  const clear = () => {
    sigCanvas.current.clear();
    setIsEmpty(true);
  };

  const handleEnd = () => {
    setIsEmpty(sigCanvas.current.isEmpty());
  };

  const save = () => {
    if (sigCanvas.current.isEmpty()) {
      alert('Veuillez signer avant de valider');
      return;
    }
    const signatureData = sigCanvas.current.toDataURL();
    onSave(signatureData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full p-6">
        <div className="mb-4">
          <h2 className="text-2xl font-bold text-gray-800">Signature électronique</h2>
          <p className="text-gray-600 mt-2">
            {documentType === 'quote' ? 'Devis' : 'Facture'} N°{documentNumber}
          </p>
          <p className="text-sm text-gray-500">Client : {clientName}</p>
        </div>

        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            Signez dans le cadre ci-dessous avec votre souris ou votre doigt
          </p>
          <div className="border-2 border-gray-300 rounded-lg overflow-hidden bg-white">
            <SignatureCanvas
              ref={sigCanvas}
              canvasProps={{
                width: 600,
                height: 300,
                className: 'signature-canvas w-full h-full'
              }}
              backgroundColor="white"
              onEnd={handleEnd}
            />
          </div>
        </div>

        <div className="flex justify-between items-center">
          <button
            onClick={clear}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Effacer
          </button>
          <div className="flex gap-2">
            <button
              onClick={onCancel}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Annuler
            </button>
            <button
              onClick={save}
              disabled={isEmpty}
              className={`px-6 py-2 rounded-lg transition-colors ${
                isEmpty
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  : 'bg-orange-500 text-white hover:bg-orange-600'
              }`}
            >
              Valider la signature
            </button>
          </div>
        </div>

        <div className="mt-4 p-3 bg-blue-50 rounded-lg">
          <p className="text-xs text-blue-800">
            ℹ️ En signant ce document, vous confirmez avoir lu et accepté les termes et conditions.
            Cette signature a la même valeur qu'une signature manuscrite.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignaturePad;
